<template>
  <HeadlineComponent>Dein Profil</HeadlineComponent>
  <Form
    class="form-horizontal"
    @submit="onSubmit"
    :initialValues="form"
    v-if="form.id"
  >
    <UserForm :disableShirtCheckbox="true" pw-rules="min:6"></UserForm>
    <template v-if="isTeamlead">
      <h2>Benachrichtigungseinstellungen</h2>
      <div class="form-group">
        <div class="form-check">
          <Field
            type="checkbox"
            name="prefer_ntfy_notifications"
            class="form-check-input"
            id="prefer_ntfy_notifications"
            :value="true"
          />
          <label class="form-check-label" for="prefer_ntfy_notifications">
            Benachrichtigungen via Ntfy bevorzugen
          </label>
        </div>
      </div>
      <div v-if="user.ntfy_link" class="mb-2">
        <p>
          Benachrichtigungen laufen nun über ntfy. Du kannst die
          Benachrichtigungen entweder über den Browser empfangen:

          <a :href="user.ntfy_link" target="_blank" ref="ntfylink">{{
            user.ntfy_link
          }}</a>
        </p>
        <p>
          oder über dein Handy. Dazu musst du die App ntfy installieren (<a
            href="https://play.google.com/store/apps/details?id=io.heckel.ntfy"
            target="_blank"
            >Android</a
          >,
          <a
            href="https://apps.apple.com/us/app/ntfy/id1625396347"
            target="_blank"
            >iPhone</a
          >)
        </p>
        <p>
          Android User können, sobald die App installiert ist, einfach auf den
          folgenden Link klicken:
          <a :href="makeAppLink(user.ntfy_link)" target="_blank">{{
            makeAppLink(user.ntfy_link)
          }}</a>
        </p>
        <p>
          iPhone User müssen die App öffnen, oben rechts auf das "+" drücken und
          anschließend als den Topic Namen ausfüllen und den Haken bei "Einen
          anderen Server nutzen" bzw "Use another Server" setzen und
          anschließend den Hostnamen eingeben
          <br />
          <b
            >Topic:
            <span
              class="btn btn-secondary btn-sm mt-2"
              @click.prevent="copy(getTopic(user.ntfy_link))"
              >{{ getTopic(user.ntfy_link) }}</span
            >
            <small class="pl-2">(zum kopieren Klicken)</small><br />
            Hostname:
            <span
              class="btn btn-secondary btn-sm mt-2"
              @click.prevent="copy(getHost(user.ntfy_link))"
              >{{ getHost(user.ntfy_link) }}</span
            >
            <small class="pl-2">(zum kopieren Klicken)</small></b
          >
        </p>
        <p>Alles eingerichtet?
          <button class="btn btn-secondary btn-sm" @click.prevent="testNtfy()">Testnachricht schicken</button>
        </p>
      </div>
    </template>
    <div class="form-group">
      <input type="submit" value="Speichern" class="btn btn-primary" />
    </div>
  </Form>
</template>

<script>
import { mapState } from "pinia";
import { useUserStore } from "../stores/user.js";
import userService from "../services/user.service.js";
import { mapActions } from "pinia";
import { useAlertsStore } from "../stores/alerts.js";
import { Field, Form } from "vee-validate";
import HeadlineComponent from "../components/HeadlineComponent.vue";
import UserForm from "../components/UserForm.vue";
import { setErrors } from "@/helper/ErrorToActions.js";
import * as Sentry from '@sentry/vue';

export default {
  name: "ProfileView",
  components: {
    UserForm,
    HeadlineComponent,
    // eslint-disable-next-line vue/no-reserved-component-names
    Form,
    Field,
  },
  data() {
    return {
      form: {},
    };
  },
  mounted() {
    if (this.user.id) {
      this.setForm(null, { user: this.user });
    } else {
      useUserStore().$subscribe(this.setForm);
    }
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    ...mapActions(useUserStore, ["getMe", "set"]),
    setForm(_, user) {
      this.form = JSON.parse(JSON.stringify(user.user));
      this.form.email2 = this.form.email;
      if (this.form.food_allergies) {
        this.show_allergies = true;
      }
    },
    makeAppLink(link) {
      return "ntfy://" + link.replace(/(^\w+:|^)\/\//, "");
    },
    getTopic(link) {
      var a = document.createElement("a");
      a.href = link;
      return a.pathname.substring(1);
    },
    getHost(link) {
      var a = document.createElement("a");
      a.href = link;
      return a.protocol + "//" + a.host;
    },
    copy(data) {
      navigator.clipboard.writeText(data);
    },
    async onSubmit(values, actions) {
      // check if form is valid...
      try {
        let response = await userService.updateMe(values);
        this.set(response.data);
        this.addAlert("success", "Dein Profil wurde aktualisiert.");
      } catch (e) {
        if (e) {
          if (e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions);
          }
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      window.scrollTo(0, 0, { smooth: true });
    },
    async testNtfy() {
      try {
        await userService.checkNtfy();
        this.addAlert("success", "Eine Testnachricht wurde verschickt")
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    }
  },
  computed: {
    ...mapState(useUserStore, ["user", "isTeamlead"]),
  },
};
</script>

<style scoped>
@media (max-width: 575px) {
  form {
    width: 100%;
    max-width: 330px;
    margin: 0 auto;
    padding: 15px;
  }
  .form-group {
    text-align: center;
  }
}
</style>
